<div class="burger-button">
    <img class="img-burger cursor" src="/assets/icons/menu-burger.svg" alt="bouton menu déroulant" (click)="displaySidebar()">
</div>
